module.exports = __webpack_public_path__ + "img/6f243c3.jpg";